'use client';

import type { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { BackButton } from '@/app/components/BackButton';
import { usePathname } from '@/i18n/routing';
import appConst from '~/const/appConst';
import { SettingsNavigation } from './SettingsNavigation';

export const Settings = ({ children }: PropsWithChildren) => {
  const t = useTranslations('GLOBAL');
  const pathname = usePathname();
  const { index, settings } = appConst.staticRoutes;
  const [displayMain, setDisplayMain] = useState(pathname !== settings);

  return (
    <section className="profile" data-testid="settings">
      <div className="profile__header">
        <BackButton href={index} />
        <h1 className="vp-title-m profile__title">
          {t('SETTINGS')}
        </h1>
      </div>
      <SettingsNavigation setDisplayMain={setDisplayMain} />
      <div className={classNames('profile__main', {
        'profile__main--visible': displayMain,
      })}
      >
        <BackButton
          href={settings}
          {...(pathname === settings) && {
            onClick: () => setDisplayMain(false),
          }}
        />
        <div className="profile__page-content">
          {children}
        </div>
      </div>
    </section>
  );
};
